import { jsxs, jsx } from 'react/jsx-runtime';
import styles from '../StoredCreditCards/StoredCreditCards.module.scss.js';

/**
 * Display 16 dots which stands for the credit card number.
 * If lastFourDigits is a non-empty string, display 12 dots + these lastFourDigits.
 */
const MaskedCardNumber = ({ lastFourDigits, ['data-zta']: dataZta, }) => {
    // If we have the lastFourDigits, then we display them. Otherwise, we display only dots.
    const indexesBlock = lastFourDigits ? [1, 2, 3] : [1, 2, 3, 4];
    return (jsxs("div", { className: styles.creditCardDotsContainer, children: [indexesBlock.map((indexBlock) => (jsx("span", { className: styles.creditCardDots, children: [1, 2, 3, 4].map((indexDot) => (jsx("span", { className: styles.creditCardDot, children: "\u2B24" }, indexDot))) }, indexBlock))), lastFourDigits && jsx("span", { "data-zta": dataZta, children: lastFourDigits })] }));
};

export { MaskedCardNumber as default };
//# sourceMappingURL=MaskedCardNumber.js.map
